<template>
  <div :class="classes()">
    <span v-if="highlightText && hasHighlight" :class="`${el}__highlightText`">
      {{ highlightText }}
    </span>
    <input
      type="radio"
      :id="id"
      :name="name"
      :class="`${el}__input`"
      :checked="checked"
      :disabled="disabled"
      v-on="{
        ...$listeners,
        input: (event) => {
          $emit('input', event.target.value);
        },
      }"
    />
    <label :for="id" :class="`${el}__label`">
      <div :class="`${el}__labelInner`">
        <span :class="`${el}__text`">
          <Icon
            v-if="checkmark"
            color="neutral0"
            name="check-fill"
            size="m"
            :class="`${el}__svg`"
          />
          {{ label }}
          <Copy v-if="subLabel" element="div" :staticClass="`${el}__subLabel`">
            {{ subLabel }}
          </Copy>
        </span>
      </div>
    </label>
  </div>
</template>

<script>
import Icon from '@/objects/Icon';
import Copy from '@/objects/Copy';
export default {
  name: 'BaseRadio',
  components: {
    Icon,
    Copy,
  },
  props: {
    id: String,
    name: String,
    label: String,
    subLabel: String,
    checked: {
      type: Boolean,
      default: false,
    },
    error: {
      type: [String, Boolean],
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    checkmark: {
      type: Boolean,
      default: false,
    },
    advanced: {
      type: Boolean,
      default: false,
    },
    hasHighlight: {
      type: Boolean,
      default: false,
    },
    hasPadding: {
      type: Boolean,
      default: false,
    },
    hasMargin: Boolean,
    highlightText: String,
  },
  data() {
    return {
      inputChecked: this.checked,
      el: 'o-baseRadio',
      classes: () => {
        const el = this.el;
        return {
          [el]: true,
          'is-error': this.error,
          'is-disabled': this.disabled,
          [`${el}--advanced`]: this.advanced,
          [`${el}--checkmark`]: this.checkmark,
          [`${el}--hasHighlight`]: this.hasHighlight,
          [`${el}--hasPadding`]: this.hasPadding,
          [`${el}--hasMargin`]: this.hasMargin,
          [`${el}--empty`]: !this.label,
        };
      },
    };
  },
};
</script>
